import { Component, Input } from '@angular/core';
import { UploadFileDialogImprovedComponent } from '@partner/shared/upload-file-dialog-improved/upload-file-dialog-improved.component';
import { MatDialog } from '@angular/material/dialog';
import { AppUppyFile } from 'common';
import { DocumentCategory } from 'common';
import { RequirementData, RequirementDocumentData, RequirementsIndicatorType } from './requirement-documents-panel.model';
import { SubmissionDetailsActionsService } from '../../../actions/submission-details-actions.service';
import { DownloadRequirementDocumentData, DeleteRequirementDocumentData, SaveRequirementDocumentData } from '../../../../../domain/models/submissions.model';

@Component({
    selector: 'ifbp-requirement-documents-panel',
    templateUrl: './requirement-documents-panel.component.html',
    styleUrls: ['./requirement-documents-panel.component.scss'],
    standalone: false
})
export class RequirementDocumentsPanelComponent {
  @Input()
  requirement: RequirementData;

  @Input()
  canMarkInvalidPanel?: boolean;

  readonly IndicatorType = RequirementsIndicatorType;

  constructor(
    private readonly actions: SubmissionDetailsActionsService,
    private readonly dialog: MatDialog
  ) { }

  onDocumentNameClick(document: RequirementDocumentData): void {
    if (!document.isDownloadable) {
      return;
    }

    const data: DownloadRequirementDocumentData = {
      requirementId: this.requirement.requirementId,
      documentId: document.id,
      filename: document.name
    };

    if (this.requirement.useLoaderWhenDownloading) {
      this.requirement.isLoading = true;
    }
    this.actions.downloadRequirementDocument(data);
  }

  onRemoveDocumentClick(document: RequirementDocumentData): void {
    const data: DeleteRequirementDocumentData = {
      requirementId: this.requirement.requirementId,
      documentId: document.id,
    };

    if (this.requirement.useLoaderWhenDeleting) {
      this.requirement.isLoading = true;
    }
    this.actions.deleteRequirementDocument(data);
  }

  onUploadDocumentClick(): void {
    const dialogRef = UploadFileDialogImprovedComponent.open(this.dialog, { maxFileCount: this.requirement.maxDocumentsCountToUpload ?? 0 });
    dialogRef.afterClosed().subscribe((uploadedFiles?: AppUppyFile[]) => {
      if (!uploadedFiles || uploadedFiles.length === 0) {
        return;
      }

      const data: SaveRequirementDocumentData[] = uploadedFiles?.map((file: AppUppyFile) => {
        return {
          requirementId: this.requirement.requirementId,
          category: <DocumentCategory>this.requirement.category,
          name: file.name,
          type: <string>file.type,
          data: file.data as Blob
        };
      })

      if (this.requirement.useLoaderWhenUploading) {
        this.requirement.isLoading = true;
      }
      this.actions.saveRequirementDocuments(data);
    });
  }
}
